export default {
  paraDolar: function(valor) {
    if (!valor) return '';

    return parseFloat(`${valor}`.replace(/\./g, '').replace(/,/g, '.'));
  },
  paraReal: function(valor) {
    if (!valor) return valor;

    const formato = new Intl.NumberFormat('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    return formato.format(isNaN(valor) ? 0 : valor);
  },
  paraCambio: function (valor) {
    if (!valor) return valor;

    const formato = new Intl.NumberFormat('pt-BR', {
      minimumFractionDigits: 1,
      maximumFractionDigits: 5
    });

    return formato.format(isNaN(valor) ? 0 : valor);
  }
}



// WEBPACK FOOTER //
// ./FrontEnd/js/converter-moeda.js